module.exports = __webpack_public_path__ + "img/logo-supreme.b9b04ec.webp";